class QuickOrderList {
  constructor() {
    this.forms = document.querySelectorAll('quick-order-list form');
    if (!this.forms.length) return;

    this.forms.forEach((form) => {
      form.addEventListener('submit', this.onSubmit.bind(this));
    });
  }

  async onSubmit(event) {
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('[type="submit"]');

    if (submitButton) submitButton.setAttribute('aria-disabled', 'true');

    const formData = new FormData(form);
    formData.append(
      'sections',
      JSON.stringify(this.getSectionsToRender())
    );

    try {
      const response = await fetch('/cart/update', {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });

      const data = await response.json();

      /* ✅ FIX 1: Sold out / 422 handling */
      if (!response.ok) {
        console.warn('Quick order list error:', data);

        if (data?.errors) {
          alert(data.errors);
        }

        return;
      }

      /* ✅ FIX 2: Section safety guard */
      if (!data.sections) {
        console.warn('No sections returned from cart update.');
        return;
      }

      this.renderSections(data.sections);

    } catch (error) {
      console.error('Quick order list JS error:', error);
    } finally {
      if (submitButton) submitButton.removeAttribute('aria-disabled');
    }
  }

  renderSections(sections) {
    Object.keys(sections).forEach((sectionId) => {
      const section = document.getElementById(sectionId);

      /* ✅ FIX 3: Prevent undefined section crash */
      if (!section) {
        console.warn(`Section ${sectionId} not found in DOM.`);
        return;
      }

      section.innerHTML = sections[sectionId];
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text'
      },
      {
        id: 'quick-order-list',
        section: 'quick-order-list'
      }
    ];
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new QuickOrderList();
});
